module.exports = __webpack_public_path__ + "static/ss2-3f3188a999469fec3a486006caf2b177.png";